import { render, staticRenderFns } from "./DaftarUserView.vue?vue&type=template&id=ad0a0326"
import script from "./DaftarUserView.vue?vue&type=script&lang=js"
export * from "./DaftarUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports